import { useState, useEffect } from 'react'
import cx from 'classnames'
import { DesignPreviewModalProps } from '../Types'
import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './DesignContent.module.scss'
import { DesignContentPreview } from 'components/DesignContentPreview/DesignContentPreview'
import { Button } from 'blaze-ui/Button'
import { Heading } from 'blaze-ui/Heading/Heading'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { ChevronLeft, ChevronRight } from 'blaze-ui/icons/24'

export const DesignPreviewModal = ({ initialOption, content, aspectRatio, onUseDesign }: DesignPreviewModalProps) => {
  const [option, setOption] = useState(initialOption)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const { closeModal } = useModals()
  const isLandscape = aspectRatio > 1

  useEffect(() => {
    if (isFirstRender) {
      const timer = setTimeout(() => {
        setIsFirstRender(false)
      }, 250)
      return () => clearTimeout(timer)
    }
  }, [isFirstRender])

  const handleUseDesign = () => {
    onUseDesign?.(content[option])
    closeModal()
  }

  return (
    <Modal.Root size="md" onPressOutside={closeModal}>
      <Modal.Header>
        <Heading level={3}>Option {option + 1}</Heading>
      </Modal.Header>
      <div className={cx(Styles.modalBody, { [Styles.landscape]: isLandscape })}>
        <div>
          {option > 0 && content.length > 1 && (
            <IconButton
              rounded
              size="lg"
              variant="secondary"
              icon={ChevronLeft}
              onPress={() => setOption(option - 1)}
              aria-label="Previous design"
            />
          )}
        </div>
        <div className={cx(Styles.designPreview, { [Styles.landscape]: isLandscape })} style={{ aspectRatio }}>
          {!isFirstRender && <DesignContentPreview key={option} content={content[option]} />}
        </div>
        <div>
          {option < content.length - 1 && content.length > 1 && (
            <IconButton
              rounded
              size="lg"
              variant="secondary"
              icon={ChevronRight}
              onPress={() => setOption(option + 1)}
              aria-label="Next design"
            />
          )}
        </div>
      </div>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button size="lg" variant="tertiary" onPress={closeModal}>
            Close
          </Button>
        </Modal.FooterContent>
        {onUseDesign && (
          <Modal.FooterContent slot="right">
            <Button size="lg" onPress={handleUseDesign}>
              Use This Design
            </Button>
          </Modal.FooterContent>
        )}
      </Modal.Footer>
    </Modal.Root>
  )
}
